import React from "react";

import { IconButton, IconButtonProps } from "../IconButton";

import styles from "./Drawer.scss";

export function CloseDrawerButton({
  size = 16,
  text = "",
  onClick,
}: {
  size?: IconButtonProps["iconSize"];
  text?: string | JSX.Element;
  onClick: () => void;
}) {
  return (
    <IconButton
      iconSize={size}
      onClick={onClick}
      icon="close"
      className={styles.drawerButton}
      data-testid="drawer-close-button"
      type="button"
    >
      {text ? text : <span>{text}</span>}
    </IconButton>
  );
}
